import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input, Button, Form, message } from "antd";
import { useDispatch } from "react-redux";
import { setUser } from "../store/userSlice";
import Cookies from "js-cookie"; // Import js-cookie
import { FaUser, FaLock } from "react-icons/fa"; // React Icons
import SummaryApi from "../common";
const AdminLogin = () => {
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleLogin = async () => {
    if (!username || !password) {
      message.error("Username and password are required.");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(SummaryApi.adminLogin.url, {
        method: "POST", // Use POST method
        headers: {
          "Content-Type": "application/json", // Specify content type as JSON
        },
        body: JSON.stringify({
          user_name: username,
          password: password,
        }), // Send the username and password in the request body
      });
      const data = await response.json();
      console.log("API Response:", data); // Log the full API response
      // Check for successful login response
      if (data.status && data.admin_id && data.user_name) {
        // Assuming the login is successful if status is true, and user details are returned
        dispatch(
          setUser({
            admin_id: data.admin_id,
            user_name: data.user_name,
          })
        );
        // Store admin_id in cookies
        Cookies.set("admin_id", data.admin_id, { expires: 7 }); // Cookie will expire in 7 days
        // navigate("/admin-panel");
        navigate("/admin-panel/dashboard");
        message.success("Login successful!");
      } else {
        message.error("Invalid username or password.");
      }
    } catch (error) {
      message.error("An error occurred while trying to log in.");
    }
    setLoading(false);
  };
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="w-full max-w-sm p-6 bg-white shadow-md rounded-lg">
        <h2 className="text-2xl font-semibold text-center text-gray-700 mb-6">Admin Login</h2>
        <Form onFinish={handleLogin}>
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: "Please enter your username" }]}
          >
            <div className="flex items-center border rounded-lg bg-gray-50 px-4 py-1">
              <FaUser className="text-gray-500 mr-2" />
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
                className="border-none outline-none bg-transparent"
              />
            </div>
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please enter your password" }]}
          >
            <div className="flex items-center border rounded-lg bg-gray-50 px-4 py-1">
              <FaLock className="text-gray-500 mr-2" />
              <Input.Password
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="border-none outline-none bg-transparent"
              />
            </div>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              block
              htmlType="submit"
              loading={loading}
              className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1 rounded-lg"
            >
              Login
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
export default AdminLogin;